import { Controller } from "@hotwired/stimulus";
import { loadStripe } from "@stripe/stripe-js";

export default class extends Controller {
  static values = {
    clientSecret: String,
    saleSecret: String,
    publishableKey: String,
  };

  async connect() {
    this.stripe = null;
    await this.initializeAndConfirm();
  }

  async initializeAndConfirm() {
    try {
      this.stripe = await loadStripe(this.publishableKeyValue);

      if (!this.stripe) {
        this.showError("Error al cargar Stripe.js");
        return;
      }

      const returnUrl = `${window.location.origin}/gateways/stripe/${this.saleSecretValue}/callback`;
      const paymentMethodId = this.getPaymentMethodId();

      const confirmData = { return_url: returnUrl };
      if (paymentMethodId) {
        confirmData.payment_method = paymentMethodId;
      }

      const { error, paymentIntent } = await this.stripe.confirmCardPayment(
        this.clientSecretValue,
        confirmData
      );

      if (error) {
        console.error("[StripeConfirmPayment] Payment error:", error);

        if (error.type === 'card_error' || error.type === 'validation_error') {
          this.showError(error.message);
        } else {
          this.showError("Ocurrió un error. Por favor intenta nuevamente.");
        }

        setTimeout(() => {
          window.location.href = `${window.location.origin}/${this.saleSecretValue}`;
        }, 3000);
      } else if (paymentIntent) {
        if (paymentIntent.status === "succeeded") {
          window.location.href = `${window.location.origin}/gateways/stripe/${this.saleSecretValue}/callback`;
        } else if (paymentIntent.status === "requires_action") {
          const nextAction = paymentIntent.next_action;
          if (nextAction?.type === "redirect_to_url" && nextAction.redirect_to_url?.url) {
            window.location.href = nextAction.redirect_to_url.url;
          } else {
            console.error("[StripeConfirmPayment] requires_action no manejado:", nextAction);
            this.showError("Se requiere autenticación adicional. Por favor intenta nuevamente.");
            setTimeout(() => {
              window.location.href = `${window.location.origin}/${this.saleSecretValue}`;
            }, 3000);
          }
        } else {
          console.error("[StripeConfirmPayment] Status inesperado:", paymentIntent.status);
          this.showError("Error inesperado al procesar el pago.");
          setTimeout(() => {
            window.location.href = `${window.location.origin}/${this.saleSecretValue}`;
          }, 3000);
        }
      }
    } catch (error) {
      console.error("[StripeConfirmPayment] Error:", error);
      this.showError("Error al procesar el pago. Por favor intenta nuevamente.");
      setTimeout(() => {
        window.location.href = `${window.location.origin}/${this.saleSecretValue}`;
      }, 3000);
    }
  }

  getPaymentMethodId() {
    const form = document.querySelector('form[action*="checkout_form"]');
    if (!form) return null;

    const pmInput = form.querySelector('input[name*="[stripe_token][id]"]');
    return pmInput?.value || null;
  }

  showError(message) {
    const errorEl = document.getElementById("payment-error");
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.classList.remove("hidden");
    }
  }
}
